var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0202 15.0003L24.5816 7.43892C25.1401 6.88035 25.1401 5.97749 24.5816 5.41893C24.023 4.86036 23.1202 4.86036 22.5616 5.41893L15.0002 12.9803L7.4389 5.41893C6.88034 4.86036 5.97749 4.86036 5.41892 5.41893C4.86036 5.97749 4.86036 6.88035 5.41892 7.43892L12.9803 15.0003L5.41892 22.5617C4.86036 23.1203 4.86036 24.0231 5.41892 24.5817C5.69749 24.8603 6.0632 25.0002 6.42891 25.0002C6.79462 25.0002 7.16033 24.8603 7.4389 24.5817L15.0002 17.0203L22.5616 24.5817C22.8402 24.8603 23.2059 25.0002 23.5716 25.0002C23.9373 25.0002 24.303 24.8603 24.5816 24.5817C25.1401 24.0231 25.1401 23.1203 24.5816 22.5617L17.0202 15.0003Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.22039e71.svg";
export { ForwardRef as ReactComponent };